import {Link} from "react-router-dom";

import {COLOR_SCHEME} from "../../utilities/colorSheme";
import HiddenContainer from "../conteiners/hiddenContainer/HiddenContainer";
import ReactTable from "../conteiners/ReactTable";
import useColumns from "../Requests/OrderProcessing/utils/hooks/useColumns";
import Title from "../UI/Title/Title";

const MainPageSection = ({
  columnsConst,
  data = [],
  loading = false,
  title = "",
  linkTo = "",
  paginatable = false,
  onPaginate,
  page,
}) => {
  const columns = useColumns(columnsConst);

  return (
    <div className="fcCol w100 aistr gap0_5 fGrow" id={linkTo}>
      <div className="row w100 gap3x">
        <Link to={linkTo} style={{color: COLOR_SCHEME.LINK}}>
          <Title text={title} className="mb0_5" />
        </Link>
      </div>
      <HiddenContainer isShown={true} className="fGrow fcCol aistr" contentClassName="fGrow fcCol aistr">
        <ReactTable
          columns={columns}
          defaultData={data}
          selectable={false}
          className="scrollX fGrow"
          loading={loading}
          style={{height: "20rem"}}
          paginatable={paginatable}
          paginationPageView
          onPaginate={onPaginate}
          currentPage={page?.currentPage}
          totalPages={page?.totalPages}
          tableClassName="fGrow"
        />
      </HiddenContainer>
    </div>
  );
};

export default MainPageSection;
